import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const secureFiltersDirectoryRedirectRoute: InvariantJiraRoute = {
	name: 'filters-directory-secure-redirect',
	path: '/secure/ManageFilters.jspa',
};
